import Vue from 'vue';
import Router from 'vue-router';

import StartView from "@/jobs/views/StartView";
import OnlineTestView from "@/jobs/views/OnlineTestView";
import JobsView from "@/jobs/views/JobsView";
import LeaveContactInfoView from "@/jobs/views/LeaveContactInfoView";
import ApplyJobView from "@/jobs/views/ApplyJobView";

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: '/online-testi-aloitus',
      name: 'start',
      component: StartView,
    },
    {
      path: '/online-testi',
      name: 'online_test',
      component: OnlineTestView,
    },
    {
      path: '/',
      name: 'jobs',
      component: JobsView,
      props: true,
      params: {
        testView: '0',
      },
    },
    {
      path: '/tyopaikka/:selectedJobId',
      name: 'job',
      component: JobsView,
      props: true,
    },
    {
      path: '/jata-yhteystietosi',
      name: 'leave_contact_info',
      component: LeaveContactInfoView,
    },
    {
      path: '/hae-paikkaa/:jobId',
      name: 'apply_job',
      component: ApplyJobView,
      props: true,
    },
    {
      path: '*',
      redirect: '/',
    },
  ],
})
